import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { YandexMapComponentService } from './yandex-map.component.service';

@Component({
  selector: 'sd-ymap',
  template: '',
  styleUrls: ['./yandex-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [YandexMapComponentService],
  standalone: false,
})
export class YandexMapComponent implements AfterViewInit, OnChanges, OnDestroy {
  /**
   * Cписок гео объектов
   */
  @Input() geoObjects: ymaps.GeoObject[];
  /**
   * Нужно ли кластеризовать объекты
   */
  @Input() isClustered = false;
  /**
   * Конфигурация кластера
   */
  @Input() clusterOptions: ymaps.IClustererOptions;
  /**
   * Эмитит событие после инициализации карты и
   * возвращает ссылку на созданный инстанс
   */
  @Output() created = new EventEmitter<ymaps.Map>();

  private subscription = new Subscription();

  constructor(
    public yandexMapComponentService: YandexMapComponentService,
    private elementRef: ElementRef,
    private windowRef: WindowRef,
  ) {}

  ngAfterViewInit(): void {
    if (this.windowRef.isBrowser()) {
      this.subscription.add(
        this.yandexMapComponentService.create(this.elementRef.nativeElement).subscribe((mapInstance: ymaps.Map) => {
          this.created.emit(mapInstance);

          if (this.geoObjects) {
            this.yandexMapComponentService.addGeoObjects(this.geoObjects, this.isClustered, this.clusterOptions);
          }
        }),
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.yandexMapComponentService.isCreated() && changes.geoObjects && !changes.geoObjects.firstChange) {
      this.yandexMapComponentService.addGeoObjects(this.geoObjects, this.isClustered, this.clusterOptions);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
